
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/win-together",
      function () {
        return require("private-next-pages/win-together.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/win-together"])
      });
    }
  